<template>
    <div>
        <form
            :action="formAction"
            method="post"
            :name="name"
            :ref="name"
            style="display: none;"
        >
            <input
                name="_method"
                type="hidden"
                value="POST"
            >
        </form>
        <a
            :class="linkClass"
            href="#/"
            @click="submit"
        >
            <slot></slot>
        </a>
    </div>
</template>

<script>
export default {
    name: 'PostLink',

    props: {
        action: {
            required: true,
            type: String,
        },
        linkClass: {
            default: '',
            required: false,
            type: String,
        },
        name: {
            required: true,
            type: String,
        },
        query: {
            default: '',
            required: false,
            type: String,
        },
        confirmationMessage: {
            default: '',
            required: false,
            type: String,
        },
    },

    computed: {
        formAction() {
            if (!this.query.length) {
                return this.action;
            }

            return `${this.action}?${this.query}`;
        },
    },

    methods: {
        submit(event) {
            if (this.confirmationMessage) {
                event.preventDefault();

                if (confirm(this.confirmationMessage)) {
                    this.$refs[this.name].submit();
                    return false;
                }
            } else {
                this.$refs[this.name].submit();
                return false;
            }
        },
    },
}
</script>



// WEBPACK FOOTER //
// src/Assets/components/Utility/Buttons/PostLink.vue